import type { FunctionComponent } from 'react';

import IconCheck from 'assets/images/icon-check-16px.svg';
import IconCross from 'assets/images/icon-cross-16px.svg';

import S from './style.scss';

type PropsT = {
  children: string;
  pass: boolean | undefined;
};

export const CheckItem: FunctionComponent<PropsT> = ({ children, pass }) => {
  let containerClassName = S.container;

  if (pass === true) containerClassName += ` ${S.pass}`;
  else if (pass === false) containerClassName += ` ${S.fail}`;

  return (
    <div className={containerClassName}>
      {pass === false ? <IconCross /> : <IconCheck />}
      {children}
    </div>
  );
};
